<template>
    <b-tabs content-class="mt-3">
        <b-tab title="Listas de Checkeo" active>
            <app-supervision-checklist /> 
        </b-tab>
        <b-tab title="Pareto Indicadores">
            <app-supervision-indicators />
        </b-tab>
    </b-tabs>
</template>
<script>
import SupervisionChecklist from './SupervisionChecklist/SupervisionChecklist';
import SupervisionIndicators from './SupervisionIndicators/SupervisionIndicators';
export default {
    name: 'supervision_menu',
    components: {
        appSupervisionChecklist: SupervisionChecklist,
        appSupervisionIndicators: SupervisionIndicators
    }
}
</script>